import React from 'react';

import Track from 'ha/components/track/SmartTrack';
import Modal from 'ha/ui/next/Modal';
import Paper from 'ha/ui/next/Paper';
import SearchMapPreview from '../SearchMapPreview';
import Pin from './Pin';
import { MapProps, RoomMarker as RoomMarkerType } from './Types';

interface Props {
  marker: RoomMarkerType;
  highlightedRoomId: number;
  lat: number;
  lng: number;
  highlightedInList: boolean;
}

const RoomMarkerMobile: React.FC<Props & Partial<MapProps>> = ({
  marker,
  highlightedRoomId,
  highlightedInList,
  $hover: hovered,
}) => {
  const [isOpen, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <Track name="Clicked on a pin with price in map" type="button">
        <div onClick={() => setOpen(true)}>
          <Pin
            marker={marker}
            emphasis={hovered || highlightedInList}
            highlightedRoomId={highlightedRoomId}
          />
        </div>
      </Track>
      <Modal
        open={isOpen}
        BackdropProps={{ invisible: true }}
        onBackdropClick={() => setOpen(false)}
      >
        <Paper
          style={{
            bottom: '1rem',
            position: 'absolute',
            right: 0,
            left: 0,
            width: '17rem',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <SearchMapPreview
            rooms={marker.rooms}
            onClose={() => setOpen(false)}
          />
        </Paper>
      </Modal>
    </React.Fragment>
  );
};

export default RoomMarkerMobile;
